import { c as _c } from "react/compiler-runtime";
import type { KingFanInMessage } from '@module/types/centrifuge/public-message/inMessageTypes';
interface Props {
  item: KingFanInMessage;
}
export default function KingFanInChat(props) {
  const $ = _c(2);
  const {
    item
  } = props;
  const {
    message
  } = item.data;
  const t0 = `팬클럽 회장 ${message.nick} 님께서 입장하셨습니다.`;
  let t1;
  if ($[0] !== t0) {
    t1 = <div className="mb-[3px] whitespace-pre-wrap text-cht_entr_fk"><div>{t0}</div></div>;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}